// src/pages/AdminSeasonSetupShell.js
//
// Season Setup sub-nav shell. Wraps the five tabs that were previously
// top-level admin tabs:
//   Season Setup   — tournament creation and round management
//   Teams          — team bulk import and management
//   Seeding        — assign seeds to tournament teams
//   Pool Config    — create and configure pools and scoring rules
//   Enrollment     — enroll participants in pools
//   Initialize Games — generate game brackets

import React, { useState } from 'react';
import AdminSeasonSetup   from './AdminSeasonSetup';
import AdminTeams         from './AdminTeams';
import AdminSeeding       from './AdminSeeding';
import AdminPoolConfig    from './AdminPoolConfig';
import AdminEnrollment    from './AdminEnrollment';
import AdminGenerateGames from './AdminGenerateGames';

const SUB_TABS = [
    { id: 'season',     label: 'Season Setup'     },
    { id: 'teams',      label: 'Teams'             },
    { id: 'seeding',    label: 'Seeding'           },
    { id: 'poolconfig', label: 'Pool Config'       },
    { id: 'enrollment', label: 'Enrollment'        },
    { id: 'games',      label: 'Initialize Games'  },
];

function AdminSeasonSetupShell({
    user = {},
    showFeedback,
    activeTournament,
    tournaments,
    activePool,
    onTournamentCreated,
    onTournamentUpdated,
    onPoolsChanged,
}) {
    const [subTab, setSubTab] = useState('season');

    return (
        <div>
            {/* Sub-nav */}
            <div className="flex gap-1 mb-6 border-b border-gray-800 overflow-x-auto">
                {SUB_TABS.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => setSubTab(tab.id)}
                        className={'px-4 py-2 text-sm font-bold rounded-t-lg transition-colors whitespace-nowrap ' +
                            (subTab === tab.id
                                ? 'bg-gray-950 text-orange-400 border-t border-x border-gray-800'
                                : 'text-gray-500 hover:text-gray-300')}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {subTab === 'season' && (
                <AdminSeasonSetup
                    user={user}
                    showFeedback={showFeedback}
                    activeTournament={activeTournament}
                    onTournamentCreated={onTournamentCreated}
                    onTournamentUpdated={onTournamentUpdated}
                />
            )}

            {subTab === 'teams' && (
                <AdminTeams showFeedback={showFeedback} />
            )}

            {subTab === 'seeding' && (
                <AdminSeeding
                    showFeedback={showFeedback}
                    activeTournament={activeTournament}
                />
            )}

            {subTab === 'poolconfig' && (
                <AdminPoolConfig
                    showFeedback={showFeedback}
                    tournaments={tournaments}
                    onPoolsChanged={onPoolsChanged}
                />
            )}

            {subTab === 'enrollment' && (
                <AdminEnrollment
                    user={user}
                    showFeedback={showFeedback}
                    activeTournament={activeTournament}
                />
            )}

            {subTab === 'games' && (
                <AdminGenerateGames
                    showFeedback={showFeedback}
                    activeTournament={activeTournament}
                />
            )}
        </div>
    );
}

export default AdminSeasonSetupShell;